import dayjs from "dayjs";

// Constants
export const typeOptions = [
  { label: "By Real-Time", value: "real" },
  { label: "By Hour", value: "hour" },
  // { label: "By Daypart", value: "daypart" },
];

export const TOTAL_SALES_VIEW = {
  REAL_TIME: "By Real-Time",
  HOUR: "By Hour",
  DAY_PART: "By Daypart",
};

export const defaultLabours = {
  labour: {
    act: null,
    pct: null,
  },
  targetLabour: {
    act: null,
    pct: null,
  },
  netSales: 0,
  regularPay: 0,
  overtimePay: 0,
};

export const defaultGraphData = {
  time: [],
  sales: [],
  labours: [],
};

// Functions
export const getRefinedData = (data: any) => {
  return {
    labour: data.labour,
    targetLabour: data.target_labour,
    netSales: data.sales,
    regularPay: data.pay.regular,
    overtimePay: data.pay.overtime,
  };
};

export const getTimeMapped = (
  mapData: LabourGraphDataType[],
  activeTab: string
) => {
  const data = mapData?.map((i: LabourGraphDataType) => {
    if (activeTab === TOTAL_SALES_VIEW.DAY_PART && i?.datetime)
      return i?.datetime;
    return (
      i?.datetime && dayjs(i?.datetime).tz("America/New_York").format("HH:mm")
    );
  });
  return data;
};

export const getSalesMapped = (mapData: LabourGraphDataType[]) => {
  const data = mapData?.map((i: LabourGraphDataType) => {
    return i?.sales;
  });
  return data;
};

export const getLaboursMapped = (mapData: LabourGraphDataType[]) => {
  const data = mapData?.map((i: LabourGraphDataType) => {
    return i?.labour;
  });
  return data;
};
